import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { CommonService } from "../../services/common/common.service";
import Swal from "sweetalert2";
import { Directive, Input } from "@angular/core";
import {
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
// export class ProfileComponent { npm i ng4-loading-spinner
export class ProfileComponent implements OnInit {
  newEmpData: any = [];
  ProposalData: any = [];
  customerData: any = [];
  loginId: any;
  customerActionLogsId: any;
  proposalFrm: any = [];
  submitted: any;
  serviceList = [];
  customerContactDetails = [];
  emailList: string[] = [];
  constructor(
    private router: Router,
    private _formBuilder: FormBuilder,
    public CommonService: CommonService // private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit() {
    if (localStorage.getItem("customerId") == null) {
      this.router.navigate(["/login"]);
    }
    this.loginId = localStorage.getItem("user_id");
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    const payload = {
        "customer_id": this.loginId,
        "customerActionLogsId": this.customerActionLogsId
    }
    this.CommonService.getCutomerDetailsById(
      payload
    ).subscribe((e: any) => {
      // console.log("code--->" + e.code);
      // var data = e.data;
      if (e.code == 1) {
        this.customerData = e.data[0];
        // this.customerContactDetails = e.customerContactDetailsResult;

        e.customerContactDetailsResult.forEach(
          (
            x: {
              id: any;
              email: any;
              name: any;
              designation: any;
              password: any;
            },
            index: any
          ) => {
            this.emailList.push(x.email);
            const documentArray = this.proposalFrm.controls
              .customerContactDetails as FormArray;
            documentArray.push(
              this._formBuilder.group({
                customerContactDetailsId: x.id,
                email: [
                  x.email,
                  [
                    Validators.required,
                    Validators.pattern(
                      "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"
                    ),
                  ],
                ],
                name: [x.name, Validators.required],
                designation: [x.designation, Validators.required],
                password: [""],
              })
            );
          }
        );
      } else {
      }
    });

    this.proposalFrm = this.createCountryForm();

    this.proposalFrm.controls["customerId"].setValue(this.loginId);
  }

  createCountryForm() {
    return (this.proposalFrm = this._formBuilder.group({
      customerId: ["", Validators.required],
      customerContactDetails: this._formBuilder.array([]),
    }));
  }

  getCustomerEmailDetails() {
    return (this.proposalFrm.get("customerContactDetails") as FormArray)
      .controls;
  }

  addCustomerEmailDetails() {
    const documentArray = this.proposalFrm.controls
      .customerContactDetails as FormArray;
    const newRowIndex = documentArray.length; // Calculate the index for the new row
    // console.log("New row index:", newRowIndex);

    const newRow = this._formBuilder.group({
      customerContactDetailsId: ["0"],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      name: ["", Validators.required],
      designation: ["", Validators.required],
      // password: [
      //   "",
      //   newRowIndex === documentArray.length ? Validators.required : null,
      // ], // Add password validation for new rows
      // password: ["", Validators.required], // Add password validation for new rows
      password: [
        "",
        newRowIndex === documentArray.length ? Validators.required : null,
      ], // Add password validation for new rows
    });

    documentArray.push(newRow);
  }

  deleteCustomerEmailDetails(index: any) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let customerContactDetails = this.proposalFrm.controls
          .customerContactDetails as FormArray;
        let customerContactDetailsId =
          customerContactDetails.value[index].customerContactDetailsId;
        // console.log("customerContactDetailsId--->", customerContactDetailsId);
        if (customerContactDetailsId == 0) {
          (
            this.proposalFrm.get("customerContactDetails") as FormArray
          ).removeAt(index);
          //this.toastr.success("Success !! Row deleted successfully");
          Swal.fire({
            // position: "top-end",
            icon: "success",
            title: "Row deleted successfully",
            // showConfirmButton: false,
            timer: 1500,
          });
        } else {
          const payload={"id":customerContactDetailsId,"customerActionLogsId":this.customerActionLogsId}
          this.CommonService.deleteCustomerAuthorizedEmail(
            payload
          ).subscribe((response: any) => {
            if (response.code == 1) {
              //this.toastr.success("Success !", response.msg);
              Swal.fire({
                // position: "top-end",
                icon: "success",
                title: response.msg,
                // showConfirmButton: false,
                timer: 1500,
              });

              this.router
                .navigateByUrl("/app/refresh", { skipLocationChange: true })
                .then(() => {
                  this.router.navigate(["profile"]);
                });
              return true;
            } else if (response.code == 0) {
              Swal.fire({
                // position: "top-end",
                icon: "warning",
                title: response.msg,
                // showConfirmButton: false,
                timer: 1500,
              });
              // this.toastr.error(response.msg, "Error!");
              return false;
            } else {
              Swal.fire({
                // position: "top-end",
                icon: "warning",
                title: "Record not created!",
                // showConfirmButton: false,
                timer: 1500,
              });
              // this.toastr.error("Record not created!", "Error!");
              return false;
            }
          });
        }
      }
    });
  }

  onSubmit() {
    // this.spinnerService.show();
    this.submitted = true;
    if (this.proposalFrm.invalid) {
      console.log("Error !! Record not created");
      return;
    }
    console.log("profile form value===>",this.proposalFrm.value);

    let customerContactDetailsCount = (
      this.proposalFrm.get("customerContactDetails") as FormArray
    ).length;
    if (customerContactDetailsCount === 0) {
      // alert("Atleast Email details is required.");
      Swal.fire({
        title: "Warning!",
        text: "Atleast Email details is required.",
        timer: 1500,
        icon: "warning",
      });
      return;
    }

    if (customerContactDetailsCount > 3) {
      Swal.fire({
        title: "Warning!",
        text: "Maximum Contact Details Reached: You can only add up to 3 contact details.",
        // showConfirmButton: false,
        timer: 2000,
        icon: "warning",
      });
      return;
    }
    this.CommonService.updateCustomerDetails(
      this.proposalFrm.value
    ).subscribe(
      (response: any) => {
        this.submitted = false;
        // console.log("response", response);
        // console.log("response.code", response.code);
        if (response.code == 1) {
          // alert(response.message);
          Swal.fire({
            title: "Success!",
            text: response.message,
            icon: "success",
            timer: 3000,
            // timerProgressBar: true, // Display a progress bar as the timer counts down
            // showConfirmButton: false, // Hide the "OK" button
          });
          this.router
            .navigateByUrl("/app/refresh", { skipLocationChange: true })
            .then(() => {
              this.router.navigate(["/dash"]);
            });
          return true;
        } else if (response.code == 0) {
          // alert(response.message);
          Swal.fire({
            title: "Warning!",
            text: response.message,
            icon: "warning",
            timer: 3000,
            // timerProgressBar: true, // Display a progress bar as the timer counts down
            // showConfirmButton: false, // Hide the "OK" button
          });
          return false;
        } else {
          Swal.fire({
            title: "Warning!",
            text: "Error !! Record not created",
            icon: "warning",
            timer: 3000,
            // timerProgressBar: true, // Display a progress bar as the timer counts down
            // showConfirmButton: false, // Hide the "OK" button
          });
          // alert("Error !! Record not created");
          return false;
        }
      },
      (error) => {
        console.log("failure", error);
        return false;
      }
    );
  }

  checkDuplicateEmail(emailData: any, index: number) {
    console.log("index---", index);
    console.log("email---", emailData.target.value);
    console.log("this.emailList---", this.emailList);
    const email = emailData.target.value.toLowerCase(); // Convert to lowercase
    if (this.emailList.includes(email)) {
      console.log("if");
      this.proposalFrm.controls["customerContactDetails"]["controls"][index][
        "controls"
      ]["email"].setErrors({ uniqueEmail: true });
    } else {
      console.log("else");
      this.emailList.push(email);
      this.proposalFrm.controls["customerContactDetails"]["controls"][index][
        "controls"
      ]["email"].setErrors(null);
    }
  }
}
